#import "../../../graphql/fragments/edition-stub-fragment.graphql"

query GetDripSequenceEditionStubs(
    $limit: Int!
    $cursor: String
    $dripSequenceId: ID!
    $isArchived: Boolean
) {
    dripSequence(id: $dripSequenceId) {
        id
        editions(first: $limit, after: $cursor, archived: $isArchived) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    ...EditionStubFragment
                }
            }
        }
    }
}
